/* ==========================================================================
   ELEPHANT CAFE — gallery.js
   Photo gallery, and the menu opened as a single spread.
   The track is a scroll-snap row, so swiping is native on touch and the arrow
   buttons simply scroll it. One lightbox is shared by every gallery on the
   page and by the menu card.
   ========================================================================== */
(function () {
  'use strict';

  var lb = document.querySelector('[data-lightbox]');
  if (!lb) return;

  var lbImg = lb.querySelector('[data-lb-img]');
  var lbCap = lb.querySelector('[data-lb-cap]');
  var lastFocus = null;
  var group = null;
  var index = 0;

  function open(kind) {
    lastFocus = document.activeElement;
    lb.className = 'lb lb--' + kind;
    lb.setAttribute('data-open', 'true');
    lb.setAttribute('aria-hidden', 'false');
    document.body.setAttribute('data-lb', 'true');
    var body = lb.querySelector('.lb__body');
    body.scrollTop = 0;
    body.scrollLeft = 0;
    lb.querySelector('[data-lb-close]').focus();
  }

  function close() {
    lb.removeAttribute('data-open');
    lb.setAttribute('aria-hidden', 'true');
    document.body.removeAttribute('data-lb');
    group = null;
    if (lastFocus) lastFocus.focus();
  }

  function paint() {
    if (!group) return;
    var slide = group.slides[index];
    var img = slide.querySelector('img');
    var cap = slide.querySelector('figcaption');
    if (img) {
      lbImg.src = img.currentSrc || img.src;
      lbImg.alt = img.alt || '';
    }
    lbCap.textContent = cap ? cap.textContent.trim() : '';
  }

  function step(dir) {
    if (!group) return;
    index = (index + dir + group.slides.length) % group.slides.length;
    paint();
  }

  lb.querySelectorAll('[data-lb-close]').forEach(function (b) {
    b.addEventListener('click', close);
  });
  lb.querySelector('[data-lb-prev]').addEventListener('click', function () { step(-1); });
  lb.querySelector('[data-lb-next]').addEventListener('click', function () { step(1); });

  document.addEventListener('keydown', function (e) {
    if (!lb.hasAttribute('data-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'ArrowLeft') step(-1);
    if (e.key === 'ArrowRight') step(1);
  });

  /* ---- galleries ---- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    var track = gal.querySelector('[data-gal-track]');
    var slides = gal.querySelectorAll('.gal__slide');
    var thumbs = gal.querySelectorAll('[data-goto]');
    var count = gal.querySelector('[data-gal-count]');
    var i = 0;

    function sync() {
      thumbs.forEach(function (t, n) {
        t.setAttribute('aria-current', n === i ? 'true' : 'false');
      });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
    }

    function go(n) {
      i = Math.max(0, Math.min(slides.length - 1, n));
      track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      sync();
    }

    track.addEventListener('scroll', function () {
      var n = Math.round(track.scrollLeft / track.clientWidth);
      if (n !== i) { i = n; sync(); }
    }, { passive: true });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(+t.getAttribute('data-goto')); });
    });

    var prev = gal.querySelector('[data-gal-prev]');
    var next = gal.querySelector('[data-gal-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1); });
    if (next) next.addEventListener('click', function () { go(i + 1); });

    function expand(n) {
      group = { slides: slides };
      index = n;
      lbImg.style.display = '';
      paint();
      open('gal');
    }

    var btn = gal.querySelector('[data-gal-expand]');
    if (btn) btn.addEventListener('click', function () { expand(i); });
    slides.forEach(function (s, n) {
      s.addEventListener('click', function () { expand(n); });
    });

    sync();
  });

  /* ---- the menu, as one spread ---- */
  document.querySelectorAll('[data-menu-open]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      group = null;
      lbImg.style.display = '';
      lbImg.src = btn.getAttribute('data-menu-src');
      lbImg.alt = 'Full menu, food and drinks';
      lbCap.textContent = 'Scroll or pinch to zoom';
      open('menu');
    });
  });
})();
